// The public /apps/whatsapp page is opened by anonymous customers, often on a phone
// over a weak connection. It is self-contained (plain fetch + its own socket.io client)
// and needs none of the portal: no Redux, Auth, PBX/SIP, notifications, i18n, Tailwind
// or the 80+ page configs. Booting it through the portal meant downloading and running
// all of that before the chat could paint, so a full page load of that route gets its
// own tiny entry and the portal is split into a separate chunk it never requests.
// In-app navigation to /apps/whatsapp still goes through the portal's route config.
const isPublicWhatsApp = window.location.pathname.replace(/\/+$/, '') === '/apps/whatsapp';

if (isPublicWhatsApp) {
	import('./whatsappEntry');
} else {
	import('./portalEntry');
}
